import './StaticPages.css'

function AboutPage() {
  return (
    <main className="static-page page">
      <div className="container">
        <h1>About Us</h1>
        <p>Founded in 2013 with the purpose of providing education and resources to local communities
          on the health risk and concerns associated with the foods we eat and the chemicals we use in our everyday lives.
          especially those that are marketed as "safe" or "healthy" but may contain harmful ingredients.
          and those that target vulnerable populations such as children, poor and underserved communities.
        </p>

        <h2>Our Vision</h2>
        <p>At Healthy Living Blog, we envision a world where individuals are 
            empowered to make informed choices about their health and well-being. 
            We believe that by promoting healthy eating habits, sustainable living practices, 
            and promoting holistic wellness, we can contribute to a healthier planet and a happier society.</p>
        <h2>Our Motto</h2>
        <p>Eat Healthy, Be Healthy, Live Longer!!</p>
        <h2>What We Do</h2>
        <p>
          We are dedicated to providing you with practical tips, recipes, and advice
          for living a healthier, more sustainable lifestyle. Our mission is to inspire
          and empower our readers to make positive changes in their lives and the world
          around them.
        </p>
        <p>
          From nutrition and wellness to eco-friendly living, we cover a wide range of
          topics to help you on your journey to better health and sustainability.
          Whether you're looking for delicious organic recipes, tips for reducing your
          environmental footprint, or insights into the latest health trends, we've got
          you covered.
        </p>
        <h2>Our Mission</h2>
        <p>Our goal is to provide education and resources to the general public on 
          the health risk and concerns associated with the foods we eat and the chemicals
          we use in our everyday lives. We believe that you put in your body, on your body, and keep around your home all matters 
          to your overall health and the health of our planet.</p>
        <p>Thank you for being a part of our community. Together, we can make a difference
          in our lives and the planet.</p>
        <p>Happy reading!</p>
      </div>
    </main>
  )
}

export default AboutPage
